import { Grid, Button, Typography, Card } from '@mui/material'
import { ReactComponent as User} from '../../../icons/user.svg';
import { ReactComponent as ShopIcon} from '../../../icons/shop.svg';
import colors from '../../colors';
import React from 'react'
import { makeStyles } from '@mui/styles';
import { useDispatch } from 'react-redux';
import {setAccountType, incrementCurrentRegistrationStep} from '../../../features/registration/registrationSlice'
import {texts} from '../../general/texts'

export const IndividualOrBusinessAccountTypes = () => {

    const useStyles = makeStyles({
        header:{
            color:colors.darkBlue,
            fontSize:'2rem',
            fontFamily:'GerberaBold'        
        },
        description:{
            color:colors.gray,
            fontSize:'1.3rem',
            fontFamily:'GerberaMedium',
        },
        card:{
            background:colors.cyan,
            width:'50%',
            borderRadius:'20px',
            '@media (max-width: 899px)' : {width:'90%'}
        },
        cardButton:{
            "&:hover":{backgroundColor:colors.lightGray},
            width:'100%',
            height:"100%",
            paddingBottom:'7.2%'
        },
        cardText:{
            color:colors.darkBlue,
            fontSize:'1rem',
            fontFamily:'GerberaLight',
            textTransform:'none'
        },
        cardTextGrid:{
            paddingTop:'10%',
            paddingLeft:'5%'
        }
    })

    const dispatch = useDispatch()

    const classes = useStyles()

    const handleButtonClick = (value) => 
    {
        dispatch(setAccountType(value))
        dispatch(incrementCurrentRegistrationStep())
    }

  return (
    <Grid container  >
        <Grid container pt={'5%'} rowSpacing={15} justifyContent={'center'} >
            <Grid container item md={12} xs={12} justifyContent={'center'} >
                <Typography className={classes.header} >{texts["prompt-no-account-create"]}</Typography>
            </Grid>
            <Grid container item md={12} xs={10} justifyContent={'center'} >
                <Typography className={classes.description} >{texts["message-subtitle-registration"]}</Typography>
            </Grid>
            <Grid container item md={12} spacing={5}  >
                <Grid container item md={6} xs={12} justifyContent={'right'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}}  >
                    <Card elevation={0} className={classes.card} >
                        <Button onClick={() => {handleButtonClick(-1)} } disableRipple={true} className={classes.cardButton}>
                            <Grid item container md={12} >
                                <Grid item md={3} xs={3} pt={'6%'} >
                                    <User />
                                </Grid>
                                <Grid item md={9} xs={9} className={classes.cardTextGrid}>
                                        <Typography className={classes.cardText} textAlign='left'>{texts["account-type-eWallet"]}</Typography>
                                </Grid>
                            </Grid>
                        </Button>
                    </Card>
                </Grid>
                <Grid container item md={6} xs={12} justifyContent={'left'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}}  >
                    <Card elevation={0} className={classes.card} >
                        <Button onClick={() => {handleButtonClick(2)}} disableRipple={true} className={classes.cardButton}>
                            <Grid item container md={12} xs={12} >
                                <Grid item md={3} xs={3} sx={{pt:'6%'}} >
                                    <ShopIcon />
                                </Grid>
                                <Grid item md={9} xs={9} className={classes.cardTextGrid}>
                                    <Typography className={classes.cardText}  textAlign='left'>{texts["account-type-business"]}</Typography>
                                </Grid>
                            </Grid>
                        </Button>
                    </Card>
                </Grid>
            </Grid>
        </Grid>
    </Grid>
  )
}
export default IndividualOrBusinessAccountTypes